export { autoResize } from "./autoResize.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/3rdparty/autoResize/index.mjs
// module id = 1013
// module chunks = 1